import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import type Employee from 'modules/employees/store/models/Employee'

const New = () => {
  const { navigation } = useNavigation()
  const { employee, folder } = useOutletContext<{ employee: Employee; folder: Folder }>()
  const backRoute = navigation.employees.id.documents.list.fullPath({ id: employee.attributes.id })

  return <NewDocument employee={employee} folder={folder} backRoute={backRoute} />
}

export default New
